import { apiGet, apiPost } from "./api";

const VISITOR_KEY = "ulpgl_visitor_id";

/** Identifiant anonyme persistant du visiteur (localStorage). */
export const getVisitorId = (): string => {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    // localStorage indisponible (mode privé) — id éphémère
    return `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
};

/** Enregistre une visite pour la page donnée. N'échoue jamais bruyamment. */
export const recordVisit = async (path: string): Promise<void> => {
  try {
    await apiPost("/visits", {
      visitorId: getVisitorId(),
      path,
      referrer: document.referrer || null,
    });
  } catch {
    /* tracking best-effort : on ignore les erreurs */
  }
};

export type VisitCount = { total: number; unique: number };

/** Récupère le compteur public (total + visiteurs uniques). */
export const fetchVisitCount = async (): Promise<VisitCount> => {
  try {
    const data = await apiGet("/visits/count");
    return { total: Number(data?.total) || 0, unique: Number(data?.unique) || 0 };
  } catch {
    return { total: 0, unique: 0 };
  }
};
